import React from "react";
import LogoZap from "assets/images/zap manager-vertical.png"
import LogoZapMobile from "assets/images/zap manager-horizontal.png"

import "./AuthenticationFormLogo.scoped.scss";

const AuthenticationFormLogo = ({ baseId }) => {
    return (
        <div className="loggedin_logo">
            <a href="/">
                <img id={baseId ? `${baseId}-logo` : null} src={document.body.clientWidth > 1024 ? LogoZap : LogoZapMobile} alt="" />
            </a>
        </div>
    );
}

export default AuthenticationFormLogo;